module.exports = __webpack_public_path__ + "21abef84f78b559902bf65210acab9fb.jpg";